export default __webpack_public_path__ + "static/Inter-Thin-f341ca512063c66296d117562f639107.ttf";